/*document.addEventListener('DOMContentLoaded', function () {
  const notifyBtn = document.getElementById('notify-me-btn');
  const notifyModal = document.getElementById('notify-me-modal');
  const notifyCloseBtns = notifyModal?.querySelectorAll('.modal-close, .close-modal');
  const notifyForm = document.getElementById('notify-me-form');

  // Abre modal de notificação
  notifyBtn?.addEventListener('click', (e) => {
    // Impede que o clique "suba" para o botão pai
    e.stopPropagation();
    // Abre o modal de avise-me
    notifyModal.classList.remove('hidden');
    document.body.classList.add('modal-open');
  });

  // Fecha modal
  notifyCloseBtns?.forEach(btn => {
    btn.addEventListener('click', () => {
      notifyModal.classList.add('hidden');
      document.body.classList.remove('modal-open');
    });
  });

  // Submete para eDrone (topic_observe)
  notifyForm?.addEventListener('submit', (e) => {
    e.preventDefault();
    const email = document.getElementById('notify-me-email').value;
    const productId = document.querySelector('.product-info')?.getAttribute('data-product-id') ?? '';

    const xhr = new XMLHttpRequest();
    xhr.open("POST", "https://api.edrone.me/topic_observe", true);
    xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
    xhr.onreadystatechange = () => {
      if (xhr.readyState === XMLHttpRequest.DONE) {
        if (xhr.status === 200) {
          alert("Seu interesse foi registrado! Você será notificado por e-mail.");
        } else {
          console.error("Erro ao enviar dados para eDrone:", xhr.status, xhr.responseText);
          alert("Houve um erro ao registrar seu interesse. Tente novamente.");
        }
      }
    };
    xhr.send(JSON.stringify({
      app_id: '65e8c1e39157c', // Seu app_id do eDrone
      email: email,          // E-mail digitado
      topic_id: productId,   // ID do produto (ou outro identificador)
      topic_campaign_id: 0   // 0 = design de e-mail padrão no eDrone
    }));

    // Fecha o modal após enviar
    notifyModal.classList.add('hidden');
    document.body.classList.remove('modal-open');
  });
});*/

// ======================================================================
// =============== LÓGICA DE ADD TO CART E MODAL DE CARRINHO ============
// ======================================================================
document.addEventListener("DOMContentLoaded", () => {
  const btn = document.getElementById("custom-add-to-cart");
  if (!btn || btn.type === "submit") return;

  // Puxa dados do JSON
  const productId = document
    .querySelector(".product-info")
    ?.getAttribute("data-product-id");
  const productJson = document.getElementById(`ProductJson-${productId}`);
  const product = productJson ? JSON.parse(productJson.textContent) : null;

  // Função para descobrir a variante selecionada no DOM
  function getSelectedVariant() {
    if (!product) return null;

    const selectedOptions = [];
    product.options.forEach((option, i) => {
      const fieldset = document.querySelector(
        `fieldset.product-form__input:nth-of-type(${i + 1})`
      );
      const input = fieldset?.querySelector(
        'input[type="radio"]:checked, select'
      );
      if (input) selectedOptions.push(input.value);
    });

    return product.variants.find(
      (variant) =>
        JSON.stringify(variant.options) === JSON.stringify(selectedOptions)
    );
  }

  let isAdding = false;

  // Single listener responsável por adicionar ao carrinho e abrir o modal
  btn?.addEventListener("click", async (event) => {
    if (isAdding) return; // evita duplo clique
    isAdding = true;

    const selectedVariant = getSelectedVariant();
    const quantity =
      document.querySelector('input[name="quantity"]')?.value || 1;

    if (!selectedVariant) {
      alert("Erro ao identificar a variante selecionada.");
      isAdding = false;
      return;
    }

    // Desabilita o botão durante a requisição
    btn.disabled = true;
    btn.classList.add("loading");

    const formData = new FormData();
    formData.append("id", selectedVariant.id);
    formData.append("quantity", quantity);

    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        body: formData,
      });

      const item = await res.json();
      showProductModal(item, selectedVariant);
    } catch (err) {
      console.error("Erro ao adicionar ao carrinho:", err);
    } finally {
      btn.classList.remove("loading");
      btn.disabled = false;
      isAdding = false;
    }
  });

  function showProductModal(item, variant) {
    const image = variant.featured_image?.src || item.image;
    document.getElementById("modal-product-image").src = image;
    document.getElementById("modal-product-title").textContent =
      item.product_title;
    document.getElementById("modal-product-price").textContent = formatMoney(
      item.price
    );

    const namedOptions = product.options
      .map((optionName, index) => {
        return `${optionName}: ${variant.options[index]}`;
      })
      .join(" | ");
    document.getElementById("modal-product-options").textContent = namedOptions;

    document.getElementById("product-added-modal").classList.remove("hidden");
    document.body.classList.add("modal-open");
  }

  document.querySelectorAll(".modal-close, .close-modal").forEach((el) => {
    el.addEventListener("click", () => {
      document.getElementById("product-added-modal").classList.add("hidden");
      document.body.classList.remove("modal-open");
    });
  });

  function formatMoney(cents) {
    return "R$ " + (cents / 100).toFixed(2).replace(".", ",");
  }
});
